import * as z from 'zod'
import { SourceType } from '../SourceEntity.js'

export const putSourceSchema = z.object({
    convertibleId: z.string().nullish(),
    internalComment: z.string().nullish(),
    issueId: z.string().nullish(),
    prId: z.string().nullish(),
    publishedDate: z.iso.datetime().nullish(),
    sourceType: z.enum<SourceType[]>([
        'Cancellation',
        'Conversion',
        'InformationDocument',
        'Memorandum',
        'New commitments',
        'Offset',
        'Outcome',
        'Prospectus',
        'Publication',
        'PublicationWarrant',
        'Repayment',
        'Stabilisation',
        'Supplement',
        'Terms',
        'Update',
    ]),
    sourceUrl: z.string().nullish(),
    title: z.string().nullish(),
    warrantId: z.string().nullish(),
})
